module.exports = __webpack_public_path__ + "components/country-flag/static/ag-b7b84a11ff6672758f4a6826eb70b4a2.svg";